<div
    *ngIf="filter"
    [id]="filter.id + '.' + filter.id"
    class="agpr-mediaTypeTreeFilter"
>
    <agpr-scroll-panel>
        <agpr-filter-include-exclude
            *ngIf="filter.showIncludeExclude"
            [(ngModel)]="filter.currentIncludeExclude"
            (ngModelChange)="currentIncludeExcludeChange()"
        ></agpr-filter-include-exclude>
        <div class="agpr-mediaTypeTreeFilter-toggleContainer">
            <agpr-button
                [id]="id + '.' + filter.id + (!anyOptionsSelected ? '.selectAll' : 'selectNone')"
                [style]="buttonTypes.link"
                class="agpr-mediaTypeTreeFilter-allToggle"
                (click)="selectItems()"
                [label]="(!anyOptionsSelected ? 'selectAll' : 'selectNone') | localize"
                aria-live="polite"
            >
            </agpr-button>
        </div>
        <div class="agpr-mediaTypeTreeFilterOptions">
            <agpr-tree-list
                [hideParentCheckbox]="false"
                [items]="filterOptions"
                [(selection)]="selectedOptions"
                (selectionChange)="handleChange()"
                (nodeSelect)="onNodeSelcted($event)"
                (nodeUnselect)="onNodeUnselect($event)"
                [totalResults]="filter.totalResults"
                [showCountTooltip] ="false"
            ></agpr-tree-list>
        </div>
        <div
            *ngIf="showAdditionalOptions && filter.currentIncludeExclude === includeExcludeEnum.include"
            class="agpr-mediaTypeTreeFilter-additionalOptions"
        >
            <div
                class="agpr-mediaTypeTreeFilter-additionalOptionsSeparator"
            ></div>

            <label
                class="agpr-mediaTypeTreeFilter-item"
                [attr.aria-label]="'Monitoring.filtersLocalization.archivedBroadcastOnly'| localize"
            >
                <agpr-checkbox
                    [id]="filter.id + '_' + filter.id + '_checkbox'"
                    [name]="'mediaTypeTreeFilter-' + filter.id"
                    [(ngModel)]="archivedOnly"
                    [binary]="true"
                    (ngModelChange)="handleChange()"
                >
                </agpr-checkbox>
                <span
                    class="agpr-mediaTypeTreeFilter-itemLabel"
                    [pTooltip]="'Monitoring.filtersLocalization.archivedBroadcastOnly'| localize"
                >
                    {{ 'Monitoring.filtersLocalization.archivedBroadcastOnly' | localize }}
                </span>
            </label>
        </div>
    </agpr-scroll-panel>
</div>
